/**
 * Shared Plotly bootstrap.
 *
 * react-plotly.js usually pulls the full plotly bundle (~3 MB). We import
 * the minimal dist build instead and pass it explicitly to the factory so
 * the UI bundle stays small.
 */

// @ts-expect-error -- plotly.js-dist-min has no bundled types.
import Plotly from "plotly.js-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";

export const Plot = createPlotlyComponent(Plotly);

export const PLOTLY_LAYOUT_BASE = {
  paper_bgcolor: "transparent",
  plot_bgcolor: "transparent",
  font: {
    family: "Inter, ui-sans-serif, system-ui, sans-serif",
    color: "#9aa3ad",
    size: 11,
  },
  margin: { t: 20, r: 20, b: 32, l: 48 },
  xaxis: {
    gridcolor: "#1f252d",
    zerolinecolor: "#2a323d",
    color: "#9aa3ad",
  },
  yaxis: {
    gridcolor: "#1f252d",
    zerolinecolor: "#2a323d",
    color: "#9aa3ad",
  },
  colorway: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#a855f7", "#06b6d4"],
};

export const PLOTLY_CONFIG_BASE = {
  displaylogo: false,
  responsive: true,
  displayModeBar: false,
};
